const REQUEST_FORM_COOKIE = 'zehi_rf_form_input';
const SEPARATE_REQUEST_FORM_PATH = '/start';

export { REQUEST_FORM_COOKIE, SEPARATE_REQUEST_FORM_PATH };
